<template>
  <AddApp />
</template>

<script>
// @ is an alias to /src
import AddApp from "@/components/AppLists/AppForm.vue";

export default {
  name: "AddApps",
  components: {
    AddApp,
  },
};
</script>
